module.exports = {"meta":"Speeches","persons":{"title":"Speeches & Addresses: Persons","burialSpeaker":"Address / welcome to funeral","ceremonySpeaker":"Forewords at funeral","placeholder":"Last name, first name","saveButton":"Save"},"documents":{"title":"Documents","obituaryText":"Text for obituary","funeralSpeechText":"Text for funeral speech","partySpeechText":"Text for party speech","uploadButton":"PDF upload","downloadButton":"Download","deleteButton":"Delete","filenameLabel":"File name"},"allInfo":{"title":"Speeches & Addresses: Documents"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/speeches.json
// module id = WhKv
// module chunks = 1